import { MarkExtension } from '../../../core/index.js';
import { Plugin, PluginKey, TextSelection } from 'prosemirror-state';
import { DecorationSet, Decoration } from 'prosemirror-view';
import 'prosemirror-model';
import 'prosemirror-commands';
import 'prosemirror-inputrules';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function isEmptyDoc(doc) {
    return doc.childCount === 1 && doc.firstChild.isTextblock && doc.firstChild.content.size === 0;
}

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = ".ProseMirror span.ct-plugin-placeholder{pointer-events:none}.ProseMirror span.ct-plugin-placeholder:before{color:#cecece;content:attr(data-placeholder);cursor:text;position:absolute}";
styleInject(css_248z);

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var PlaceholderExtension = /*#__PURE__*/ function(MarkExtension) {
    _inherits(PlaceholderExtension, MarkExtension);
    var _super = _createSuper(PlaceholderExtension);
    function PlaceholderExtension() {
        _classCallCheck(this, PlaceholderExtension);
        return _super.apply(this, arguments);
    }
    var _proto = PlaceholderExtension.prototype;
    _proto.plugin = function plugin(param) {
        var getView = param.getView, config = param.config;
        return new Plugin({
            key: new PluginKey(this.name),
            props: {
                decorations: function decorations(state) {
                    var doc = state.doc;
                    if (isEmptyDoc(doc)) {
                        var placeHolder = document.createElement("span");
                        placeHolder.classList.add(classNamePrefix("plugin-placeholder"));
                        placeHolder.onclick = function() {
                            var view = getView();
                            view.dispatch(view.state.tr.setSelection(TextSelection.near(state.doc.resolve(0))));
                        };
                        placeHolder.setAttribute("data-placeholder", config.placeholder);
                        return DecorationSet.create(doc, [
                            Decoration.widget(1, placeHolder, {
                                // 不让光标闪一下
                                ignoreSelection: true,
                                // 不会影响光标大小
                                side: -1
                            })
                        ]);
                    }
                }
            }
        });
    };
    _createClass(PlaceholderExtension, [
        {
            key: "name",
            get: function get() {
                return "placeholder";
            }
        }
    ]);
    return PlaceholderExtension;
}(MarkExtension);

export { PlaceholderExtension };
//# sourceMappingURL=index.js.map
